import type {
  ApiRoleOwnerItem,
  RoleOwnerItem,
} from "@/core/administration/entities/RoleOwner";

export default class RoleOwnerMapper {
  static toDomainItem(api: ApiRoleOwnerItem): RoleOwnerItem {
    return {
      id: api.id,
      name: api.name,
    };
  }

  static toDomainItems(apiItems: ApiRoleOwnerItem[]): RoleOwnerItem[] {
    return apiItems.map((item) => RoleOwnerMapper.toDomainItem(item));
  }
}
